(function () {
  'use strict';

  angular
    .module('itecAdministracio.entitats.main.llicencies')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('entitats.main.submain.llicencies.formulari', {
        url: '/formulari',
        params: {
          isNew : false,
          idLlicencia: undefined,
          errorproces: undefined
        },
        views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: function(entitatsHeaderSubmenuLinksValue){
                return entitatsHeaderSubmenuLinksValue;
              }
            }
          },
          'content@entitats.main.submain': {
              templateUrl: 'entitats/main/llicencies/formulari/formulari.tpl.html',
              controller: 'EntitatsMainLlicenciesFormulariCtrl',
              controllerAs: 'ctrl'
          }
        },
        resolve: {
          llicenciaData: function(LlicenciaFactory, $stateParams, $locale) {
            if ($stateParams.isNew){
              return {};
            }
            else if (!angular.isUndefined($stateParams.idLlicencia)
                      && $stateParams.idLlicencia !== null
                      && $stateParams.idLlicencia) {
              var form = {
                idioma : $locale.localeID
              };
              return LlicenciaFactory.get($stateParams.idEntitat, $stateParams.idLlicencia, form).catch(function(){});
            }
            else {
              return {};
            }
          },
          tyksentitatData:function(TykFactory, $stateParams, $locale) {
            return TykFactory.getTyksEntitat($stateParams.idEntitat).catch(function(){});
          },
          breadcrumbText: function($stateParams){
            if (angular.isUndefined($stateParams.idLlicencia) || $stateParams.idLlicencia === '') {
              return 'BREADCRUMB_FORMULARI_CREACIO';
            }
            else {
              return 'BREADCRUMB_LABEL';
            }
          }
        },
        breadcrumb: {
          dynamicText: '{{breadcrumbText}}',
          stateName: 'entitats.main.submain.dades.llicenciaFormulari',
          textParam: {paramName: 'label', paramValue: '{{$stateParams.llicenciaData}}'}
        },
      });
  }
}());
